import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import TopAppBar from "../components/TopAppBar";
import MainTabs from "../components/MainTabs";


const theme = createTheme({
palette: {
primary: { main: "#1976d2" },
background: { default: "#f5f7fb" },
},
shape: { borderRadius: 12 },
});


export default function TeacherPage() {
return (
<ThemeProvider theme={theme}>
<CssBaseline />
<TopAppBar />
<Container maxWidth="lg" sx={{ mt: 4 }}>
<MainTabs />
</Container>
</ThemeProvider>
);
}